import React from 'react';
import '../stylesheets/Screen.css';

function Screen({ input }){
    return(
        <div className = 'input'>
            {input}
        </div>
    );
}

export default Screen;
